import { helpers } from "../../../../packages/helpers";
import type { TypingNotificationContent } from "../../types";

const { getStringValue } = helpers.text;

type Return = {
  chatId: string;
  userId: string;
};

export const getTypingNotificationEventData = (res: unknown): Return => {
  const data = res as TypingNotificationContent;

  return {
    chatId: getStringValue(data?.chatId),
    userId: getStringValue(data?.userId),
  };
};
